import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';

export const TooltipReportStatus = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 300,
  },
});
